import {PermGroupsEnum, UserPermissionEnum} from '../../schema-types/globalTypes';
import {
  ActionType,
  BooleanField,
  CheckboxGroupField,
  RadioGroupField,
} from '../AutoForm/AutoFieldNew';

export const everythingField: BooleanField = {
  id: 'everything',
  label: 'Return all staff?',
  type: ActionType.boolean,
  initialValue: false,
  noValue: false,
  yesValue: true,
  labelNotClickable: true,
};

export const businessUnitIdsField: CheckboxGroupField = {
  id: 'businessUnitIds',
  label: 'Business Units',
  type: ActionType.checkboxGroup,
  options: [],
};

export const permissionOverrideField: BooleanField = {
  id: 'permissionOverride',
  label: 'Permission Override?',
  type: ActionType.boolean,
  initialValue: false,
  noValue: false,
  yesValue: true,
  labelNotClickable: true,
};

export const globalPermissionsField: RadioGroupField = {
  id: 'permission',
  label: 'Feature permissions',
  type: ActionType.radioGroup,
  options: [
    {
      value: UserPermissionEnum.can_access_oneview,
      label: 'Can access Oneview (kill-switch)',
    },
    {
      value: UserPermissionEnum.can_access_api_features,
      label: 'Can access API features',
    },
    {
      value: UserPermissionEnum.can_access_admin_features,
      label: 'Can access Admin features',
    },
    {
      value: UserPermissionEnum.can_change_business_unit,
      label: 'Can change business unit',
    },
  ],
};

export const groupField: RadioGroupField = {
  type: ActionType.radioGroup,
  options: [
    ...Object.keys(PermGroupsEnum).map((x) => ({
      value: x,
      label: x.replace('_', ' ').toLocaleUpperCase(),
    })),
  ],
  id: 'group',
  label: 'User group',
};
